<template>
  <button
    v-if="!isNewButton"
    :disabled="disabled"
    class="vbutton"
    :class="[
      type ? `type-${type}` : '',
      color,
      text_color ? `text-${text_color}` : '',
      hover_color ? `hover-${hover_color}` : '',
      bg_color ? `bg-${bg_color}` : '',
      icon ? icon : '',
      icon_last ? 'icon-last' : '',
      size ? `size-${size}` : '',
      block ? 'block' : '',
      { iconed: icon },
      { disabled },
      { loading },
      { padding_min }
    ]"
    @keydown.13.prevent="emit"
    @click.prevent="emit"
  >
    <span class="loader">
      <span class="loading-spinner"></span>
    </span>
    <span class="button-label">
      <span v-if="icon && !icon_last" class="button-icon"></span>
      {{ button_label }}
      <span v-if="icon && icon_last" class="button-icon"></span>
    </span>

    <slot></slot>
  </button>

  <button v-else class="vbutton-new">
    <slot></slot>
  </button>
</template>

<script>
/*
  @ simple component
  @ props: label(string mask), color(string), text_color(string), type(string), icon_name(string), disabled(bool), loading(bool), global_event(bool)
  @ emit: click
  тут маска так как если тип переводчика сменится будет достаточно поменять в одном месте в компоненте, нежели по всему проекту искать vbutton
*/
export default {
  name: 'Vbutton',

  props: {
    label: {
      type: [String, Number],
      default: ''
    },

    size: {
      type: [String],
      default: 'normal' // small, big
    },

    color: {
      type: [String],
      default: 'green' // green, grey, white, red, transparent
    },

    text_color: {
      type: [String],
      default: '' // black, dark, red, grey
    },

    hover_color: {
      type: [String],
      default: '' // grey, grey-dark
    },

    bg_color: {
      type: [String],
      default: '' // white, grey
    },

    type: {
      type: [String],
      default: 'default' // dropdown, icon
    },

    icon: {
      type: [String],
      default: ''
    },

    isNewButton: {
      type: [Boolean],
      default: false
    },

    disabled: {
      type: [Boolean],
      default: false
    },

    loading: {
      type: [Boolean],
      default: false
    },

    icon_last: {
      type: [Boolean],
      default: false
    },

    global_event: {
      type: [String],
      default: null
    },

    padding_min: {
      type: Boolean,
      default: false
    },

    text: {
      type: String,
      default: ''
    },

    block: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    button_label() {
      if (!this.text && !this.label) {
        return '';
      }
      if (this.text) {
        return this.text;
      }
      return this.$tr(this.label);
    }
  },

  methods: {
    emit($event) {
      if (this.disabled === undefined || this.disabled === false) {
        this.$emit('click', $event);
        /*
          эмитим глобальное событие, и где то слушаем, решение говеное, но временное.
        */
        if (this.global_event !== null) {
          this.$root.$emit(this.global_event);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/vars.scss';
@import '../../assets/styles/animations.scss';
@import '@/styles/variables.scss';

.vbutton {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  color: #fff !important;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.005em;
  background-color: $green !important;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  border-radius: 2px;
  text-align: center;
  box-sizing: border-box;
  max-height: 40px;
  min-height: 40px;
  height: 40px;
  border: 0 !important;

  &.block {
    width: 100%;
  }

  > i {
    font-size: 20px;
  }

  .loading-spinner {
    width: 17px;
    height: 17px;
    background-size: 17px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('/static/icons/loader.svg');
  }

  .button-label {
    display: inline-flex;
    align-items: center;
    line-height: normal;
    white-space: nowrap;
  }

  .button-icon {
    width: 12px;
    height: 12px;
  }
  &.padding_min {
    padding: 10px;
  }
  &.size-small {
    padding: 10px;
    min-height: 32px;
    height: 32px;
  }
  &.size-big {
    padding: 10px 18px;
    min-height: 40px;
    height: 40px;
    white-space: nowrap;
  }
  &.size-bigger {
    padding: 13px 20px;
    min-height: 48px;
    height: 48px;
    white-space: nowrap;
  }
  &.iconed {
    &:not(.type-icon) {
      .button-icon {
        margin-right: 10px;
      }

      &.icon-last {
        .button-icon {
          margin-left: 10px;
          margin-right: 0;
        }
      }
    }
  }

  // Colors
  &.green {
    background-color: $green !important;
    color: #fff !important;
    transition: background 0.2s;
    &.disabled {
      background-color: $green !important;
    }
    &:hover:not(.disabled) {
      background-color: $green-hover !important;
      transition: background 0.2s;
    }
  }
  &.grey {
    background-color: $grey-lighter !important;
    color: $grey-darker !important;
    transition: background 0.2s;

    &.disabled {
      background-color: $grey-lighter !important;
      opacity: 0.7;
      pointer-events: none;
    }

    &:hover:not(.disabled) {
      background-color: $grey-light !important;
      transition: background 0.2s;
    }

    &:active:not(.disabled) {
      background-color: #d2d6e0 !important;
      transition: background 0.2s;
    }

    .loading-spinner {
      background-image: url('/static/icons/loader-green.svg');
    }
  }
  &.white {
    background-color: #fff !important;
    border: 1px solid #d2d6e0 !important;
    color: #233346 !important;
    transition: background 0.2s;

    &.disabled {
      background-color: #fff !important;
    }
    &:hover:not(.disabled) {
      background-color: #f4f5f7 !important;
      border-color: #f4f5f7 !important;
      transition: background 0.2s;
    }
    &:focus {
      border-color: #fff !important;
      transition: background 0.2s;
    }

    .loading-spinner {
      background-image: url('/static/icons/loader-dark.svg');
    }
  }
  &.white-clickable {
    background-color: #fff !important;
    border: 1px solid #d2d6e0 !important;
    color: #233346 !important;
    &.disabled {
      background-color: #fff !important;
    }
    &:hover:not(.disabled) {
      background-color: #f4f5f7 !important;
      border-color: #f4f5f7 !important;
    }
    &:active:not(.disabled) {
      background-color: #e3e6ed !important;
      border-color: #e3e6ed !important;
    }
    &:focus {
      border-color: #fff !important;
    }

    .loading-spinner {
      background-image: url('/static/icons/loader-dark.svg');
    }
  }
  &.red {
    background-color: #ff594f !important;
    color: #fff !important;
    border-color: transparent !important;
    transition: background 0.2s;

    &.disabled {
      background-color: #ff594f !important;
    }
    &:hover:not(.disabled) {
      background-color: #ea4d43 !important;
      transition: background 0.2s;
    }
  }
  &.transparent {
    background-color: transparent !important;
    color: #607183 !important;
    transition: background 0.2s;

    &.disabled {
      background-color: transparent !important;
    }
    &:hover:not(.disabled) {
      background-color: #f4f5f7 !important;
    }
    &:active:not(.disabled) {
      background-color: #e3e6ed !important;
      transition: background 0.2s;
    }

    .loading-spinner {
      background-image: url('/static/icons/loader-grey.svg');
    }
  }
  // End colors

  // Text colors
  &.text-white {
    color: #fff !important;

    .loading-spinner {
      background-image: url('/static/icons/loader.svg');
    }
  }
  &.text-black {
    color: #000 !important;
  }
  &.text-dark {
    color: #233346 !important;

    .loading-spinner {
      background-image: url('/static/icons/loader-dark.svg');
    }
  }
  &.text-red {
    color: #f65046 !important;

    .loading-spinner {
      background-image: url('/static/icons/loader-red.svg');
    }
  }
  &.text-grey {
    color: #607183 !important;

    .loading-spinner {
      background-image: url('/static/icons/loader-grey.svg');
    }
  }
  &.text-green {
    color: $green !important;

    .loading-spinner {
      background-image: url('/static/icons/loader-green.svg');
    }
  }
  &.text-grey-dark {
    color: $grey-darker !important;

    .loading-spinner {
      background-image: url('/static/icons/loader-grey.svg');
    }
  }
  // End text colors

  // Types
  &.type-icon {
    padding: 10px 11px;
    min-width: 40px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px;
  }
  &.type-dropdown {
    border: 1px solid #d2d6e0 !important;
    padding-right: 42px;
    background-size: 12px auto;
    background-position: calc(100% - 20px) center;
    background-repeat: no-repeat;
    background-image: url('/static/images/elements/icon-down-dark.svg');
  }
  &.type-dropdown-dark {
    border: 1px solid #d2d6e0 !important;
    padding-right: 42px;
    background-size: 12px auto;
    background-position: calc(100% - 20px) center;
    background-repeat: no-repeat;
    background-image: url('/static/images/elements/icon-down-dark.svg');

    &:active {
      background-color: #e3e6ed !important;
      border-color: #e3e6ed !important;
    }
  }
  // End types

  // Icons

  // End icons

  .loader {
    display: none;
  }
  &.loading {
    background-image: none !important;
    pointer-events: none;
    .loader {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 0.5) !important;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      .loading-spinner {
        display: block;
      }
    }

    .button-label {
      opacity: 0;
      visibility: hidden;
    }
  }

  &.type-icon,
  &.iconed:not(.type-icon) {
    &.icon-bin {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -18px;
        background-image: url('/static/images/elements/icons_bin.svg');
        width: 16px;
        height: 18px;
        background-size: 16px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }
    &.icon-status {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icon_status.svg');
        width: 24px;
        height: 24px;
      }
    }
    &.icon-bin-red {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/red-bin.svg');
        width: 16px;
        height: 18px;
        background-size: 16px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }

    &.icon_archive {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -17px;
        background-image: url('/static/images/elements/icons_archive.svg');
        width: 17px;
        height: 17px;
        background-size: 17px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }

    &.icon_next {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icon-next.svg');
        width: 14px;
        height: 13px;
        background-size: 14px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }

    &.icon_prev {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icon-prev.svg');
        width: 14px;
        height: 13px;
        background-size: 14px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }

    &.icon_share_new {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_share_old.svg');
        width: 20px;
        height: 20px;
        background-size: 20px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 -20px;
        }
      }
    }

    &.icon_arrow_down {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_arrow_down.svg');
        width: 12px;
        height: 12px;
        background-size: 12px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 -12px;
        }
      }
    }

    &.icon_videointerview {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_videointerview.svg');
        width: 22px;
        height: 14px;
        background-size: 22px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 -14px;
        }
      }
    }

    &.icon_tests {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_tests.svg');
        width: 17px;
        height: 17px;
        background-size: 17px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          height: 18px;
          position: relative;
          top: 1px;
          background-position: 0 -17px;
        }
      }
    }

    &.icon_application {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_application.svg');
        width: 18px;
        height: 18px;
        background-size: 18px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          height: 18px;
          position: relative;
          background-position: 0 0;
        }
      }
    }

    &.icon_landing {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_landing.svg');
        width: 22px;
        height: 18px;
        background-size: 22px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          height: 18px;
          position: relative;
          background-position: 0 0;
        }
      }
    }
    &.icon_copy {
      .button-icon {
        background-repeat: no-repeat;
        background-position: -1px -21px;
        background-image: url('/static/images/elements/icons_copy.svg');
        width: 16px;
        height: 19px;
        background-size: 17px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: -1px -1px;
        }
      }
    }
    &.icon_copy2 {
      .button-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .button-icon {
        background-repeat: no-repeat;
        background-image: url('/static/images/elements/icon_copy2.svg');
        width: 21px;
        height: 21px;
        margin-right: 0;
      }
    }
    &.icon_copy3 {
      .button-label {
        color: #233346;
      }
      .button-icon {
        background-repeat: no-repeat;
        background-image: url('/static/images/elements/icon_copy2.svg');
        width: 21px;
        height: 21px;
        margin-right: 10px;
      }
    }
    &.icon_room {
      .button-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .button-icon {
        background-repeat: no-repeat;
        background-image: url('/static/images/elements/go_room.svg');
        width: 21px;
        height: 21px;
        margin-right: 0;
      }
    }
    &.icon_preview {
      .button-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 22px;
      }
      .button-icon {
        background-repeat: no-repeat;
        background-image: url('/static/images/elements/icon_preview.svg');
        width: 21px;
        height: 21px;
        margin-right: 0;
      }
    }
    &.icon_edit {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -17px;
        background-image: url('/static/images/elements/icons_edit.svg');
        width: 17px;
        height: 17px;
        background-size: 17px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }
    &.icon_xls {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -15px;
        background-image: url('/static/images/elements/icons_download_xls.svg');
        width: 15px;
        height: 15px;
        background-size: 15px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }
    &.icon_xls_blue {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -15px;
        background-image: url('/static/images/elements/icon_download_blue.svg');
        width: 15px;
        height: 15px;
        background-size: 15px auto;
      }
    }
    &.icon_letter {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -14px;
        background-image: url('/static/images/elements/icons_letter.svg');
        width: 17px;
        height: 14px;
        background-size: 17px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }
    &.icon_share {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_share_old.svg');
        width: 20px;
        height: 20px;
        background-size: 20px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 -20px;
        }
      }
    }
    &.icon_restore {
      .button-icon {
        background-repeat: no-repeat;
        background-image: url('/static/images/elements/icons_restore.svg');
        width: 17px;
        height: 17px;
        background-size: 17px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }
    &.icon_down {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 -8px;
        background-image: url('/static/images/elements/icons_down.svg');
        width: 12px;
        height: 8px;
        background-size: 12px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 0;
        }
      }
    }
    &.icon_check {
      .button-icon {
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('/static/images/elements/icon_check.svg');
        width: 21px;
        height: 12px;
        background-size: 21px auto;
      }
    }
    &.icon_link {
      .button-icon {
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('/static/images/elements/icon_link.svg');
        width: 21px;
        height: 12px;
        background-size: 21px auto;
      }
    }
  }

  &.iconed:not(.type-icon) {
    background-repeat: no-repeat;
    background-position: 20px center;
    background-size: 12px;

    &.plus {
      .button-icon {
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('/static/images/elements/plus.svg');
        width: 12px;
        height: 12px;
        background-size: 12px;
      }
    }

    &.plus_w {
      .button-icon {
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('/static/images/elements/plus_w.svg');
        width: 12px;
        height: 12px;
        background-size: 12px;
      }
    }

    &.lock_w {
      .button-icon {
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('/static/images/elements/icon_lock.svg');
        width: 24px;
        height: 24px;
        background-size: 24px;
      }
    }

    &.icon_plus {
      .button-icon {
        background-repeat: no-repeat;
        background-position: 0 0;
        background-image: url('/static/images/elements/icons_plus.svg');
        width: 12px;
        height: 12px;
        background-size: 12px auto;
      }

      &:hover:not(.disabled) {
        .button-icon {
          background-position: 0 -12px;
        }
      }
    }
  }
  &.type-add {
    background-repeat: no-repeat;
    background-position: 20px center;
    padding-left: 43px;
    background-size: 12px;
    &.grey {
      background-image: url('/static/images/elements/plus.svg');
    }
    &.green {
      background-image: url('/static/images/elements/plus_w.svg');
    }
  }

  &.hover-grey-dark {
    &:hover:not(.disabled) {
      background-color: #e3e6ed !important;
    }
    &:active:not(.disabled) {
      background-color: #d2d6e0 !important;
    }
  }

  &.icon {
    &:hover:not(.disabled) {
      background-color: red !important;
    }
  }
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px 1px #fff, 0px 0px 0px 2px #437aee;
  }

  &.width-full {
    width: 100%;
    display: block;
  }

  &.disabled {
    outline: none;
    box-shadow: none;
    cursor: default;
    opacity: 0.5;
  }
  &.not-active {
    box-shadow: none;
  }
}
</style>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.vbutton-new {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1rem; // 10px 16px
  color: #fff !important;
  font-size: $base-text-size;
  line-height: $base-text-line-height;
  // // font-family: Roboto;
  font-weight: $base-font-weight;
  letter-spacing: 0.005em;
  background-color: $green !important;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  border-radius: 2px;
  text-align: center;
  box-sizing: border-box;
  min-height: 2.5rem;
  border: 0 !important;

  & > *:not(:first-child) {
    margin-left: 0.625rem; // 10px
  }
}
</style>
